import type { ListBuilderList } from '../../../types';

/**
 * Not Usable at State (PD-16225) — the licences a customer cannot legally use
 * today, whatever word the board used.
 *
 * Chris, 2026-09-17: "a board action may have forced a cancelation or early
 * expiration … if they are showing they either need to be replaced or [you]
 * have to stop selling to that client." So this list is WIDER than the Adverse
 * Action list beside it: board actions (Suspended / Revoked / Surrendered /
 * Denied) AND administratively dead licences (Cancelled / Expired / Inactive /
 * Retired / Deceased). Pending and Unknown are excluded — neither asserts the
 * licence is dead.
 *
 * It also counts an UNCONFIRMED licence-number suggestion at 90%+ confidence,
 * not only a confirmed link, because Tier-1 auto-confirm deliberately refuses
 * to link onto a dead registry row: on 2026-09-17 all 105 of republic's risky
 * licences sat unconfirmed, so the confirmed-only Adverse Action card read
 * None. The same `licenseRegistryStanding: unusable` filter backs both this
 * list and the dashboard card, so the click-through count matches.
 *
 * Default sort is `recent-sale-desc` — the actively-buying client holding a
 * dead licence is the one to call first.
 */
export const notUsableList: ListBuilderList = {
	id: 'default-licenses-not-usable',
	cacheTTL: 300000,
	// PD-16230: the tab must read the same as the dashboard card it backs.
	name: 'Dead License',
	type: 'default',
	active: true,
	// Sits with the other risk tabs (Adverse Action is 5).
	sortOrder: 6,
	filterRules: {
		licenseRegistryStanding: {
			defaultValue: [
				{
					id: 'unusable',
					label: 'Not Usable at State',
				},
			],
			locked: true,
			hidden: true,
		},
		licenseSalesRep: {
			defaultValue: [{ id: 'ME', label: 'Me' }],
			applyDefaultIf: {
				type: 'group',
				joiner: 'AND',
				negated: false,
				children: [
					{ type: 'rule', action: 'licenses:view:any', negated: true },
				],
			},
			lockedIf: {
				type: 'group',
				joiner: 'AND',
				negated: false,
				children: [
					{ type: 'rule', action: 'licenses:view:any', negated: true },
				],
			},
			hiddenIf: {
				type: 'group',
				joiner: 'AND',
				negated: false,
				children: [
					{ type: 'rule', action: 'licenses:view:any', negated: true },
				],
			},
		},
	},
	defaultSortId: 'recent-sale-desc',
	inheritsFrom: 'default-licenses-all',
};
